module.exports = __webpack_public_path__ + "static/media/cloud-lock.b42d81fe.svg";